
import { useState, useEffect, useContext, createContext } from "react";

import { UserValidationPolling } from "../utilities/polling";


export {
  UserContextProvider,
  useUser, useUserUpdate
};


const UserContext = createContext<any>( null ); // TODO: Properly fill out

const UserUpdateContext = createContext<any>( null ); // TODO: Properly fill out


function useUser() {
  return useContext( UserContext );
}

function useUserUpdate() {
  return useContext( UserUpdateContext );
}



const USER_ITEM_KEY = "user";

function UserContextProvider( {children}: ComponentProps ) {
  // Provider handles...

  // ... Creating State
  const [user, setUser] = useState<IUser | undefined>( undefined );


  useEffect( () => {
    updateUserFromStorage();
  }, []);

  useEffect( () => {
    let pollValidationIntervalId: ReturnType<typeof setInterval>;

    if( user ) { // Only Poll when User is logged in
      const pollValidation = async () => {
        const userValid = await UserValidationPolling.checkUserValidation();

        if( !userValid ) {
          // TODO: Right now server DOES NOT KNOW that User was logged out (only Client side)
          // ... So, if Server goes down, can't just do postToLogoutEndpoint as do in useAuth.tsx
          // ... May need work w/ GPT to see if good to invalidate all Cookies upon Server start and just revalidate User Tokens afresh during each new Server start-up... (may be heavy load on Server, but for my Platform, maybe not, not yet)
          // ... ... Or could just make sure expiration is very soon and in validation API call, refresh it in some way (??) -- May be best, i.e. RefreshToken (of sorts?)
          // ... (impact right now is low, as even logged out user's API calls getting paid / secured data, not many users now and not paid yet anyways)
          // ... BUT - Need make sure Database isn't just hoarding a lotta Tokens that never get properly cleaned up cuz when Server restarts and Client forced to log out via validation API call failing, Token may never be deleted from DB
          // ... ... VERIFIED that usertokens Collection still has Token when Server crashes/restarts BUT Token properly deleted when user logs out WHILE Server's running (i.e. stale Tokens will build up for users who are logged in when Server restarts)
          clearInterval( pollValidationIntervalId );

          removeUser();
        }
      }
      pollValidationIntervalId = setInterval( pollValidation, UserValidationPolling.USER_POLLING_INTERVAL );
    }

    return () => {
      clearInterval( pollValidationIntervalId );
    }
  }, [user]);


  // ... Updating State
  const updateUser = ( userObject: IUser ) => {
    localStorage.setItem( USER_ITEM_KEY, JSON.stringify(userObject) );
    setUser( userObject );
  }

  const updateUserFromStorage = () => {
    const userItem = localStorage.getItem( USER_ITEM_KEY ); // TODO: Consider if want handle NULL here
    const userObject = userItem ? JSON.parse(userItem) : undefined;
    setUser( userObject );
  }

  const removeUser = () => {
    localStorage.removeItem( USER_ITEM_KEY );
    setUser( undefined );
  }


  // ... Persisting State down into Children
  return (
    <UserContext.Provider value={ {user} } >
      <UserUpdateContext.Provider value={ {updateUser, updateUserFromStorage, removeUser} } >
        {children}
      </UserUpdateContext.Provider>
    </UserContext.Provider>
  )
}















/* */
